module.exports = __webpack_public_path__ + "img/DosMil.cc4480c4.jpg";